// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Enums
import {
  CrewmemberGender,
  CrewmemberLanguage,
  CrewmemberTshirt,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputNumber,
} from '@vroskus/library-components';

// Helpers
import _ from 'lodash';
import {
  crewmemberGenderLabel,
  crewmemberLanguageLabel,
  crewmemberTshirtLabel,
} from 'common.language';

// Types
type $Props = $Translate & {
  item: $Model<'Crewmember'> | $ModelUpsertParams<'Crewmember'>;
};

const CrewmemberFieldsView = function ({
  item,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col>
          <AvField
            label={t('Name')}
            name={'Name'}
            required
            value={item.Name}
          />
        </Col>
        <Col>
          <AvField
            label={t('Birthdate')}
            name={'Birthdate'}
            type={'date'}
            value={item.Birthdate}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Email')}
            name={'Email'}
            required
            type={'email'}
            value={item.Email}
          />
        </Col>
        <Col>
          <AvField
            label={t('Phone')}
            name={'Phone'}
            value={item.Phone}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <InputNumber
            label={t('Weight')}
            min={0}
            name={'Weight'}
            value={item.Weight}
          />
        </Col>
        <Col>
          <AvField
            label={t('Gender')}
            name={'Gender'}
            type={'select'}
            value={item.Gender}
          >
            {item.Gender === null && (
              <option />
            )}
            {_.map(
              CrewmemberGender,
              (i) => (
                <option
                  key={i}
                  value={i}
                >
                  {t(crewmemberGenderLabel[i])}
                </option>
              ),
            )}
          </AvField>
        </Col>
        <Col>
          <AvField
            label={t('Tshirt')}
            name={'Tshirt'}
            type={'select'}
            value={item.Tshirt}
          >
            {item.Tshirt === null && (
              <option />
            )}
            {_.map(
              CrewmemberTshirt,
              (i) => (
                <option
                  key={i}
                  value={i}
                >
                  {t(crewmemberTshirtLabel[i])}
                </option>
              ),
            )}
          </AvField>
        </Col>
        <Col>
          <AvField
            label={t('Language')}
            name={'Language'}
            required
            type={'select'}
            value={item.Language}
          >
            {_.map(
              CrewmemberLanguage,
              (i) => (
                <option
                  key={i}
                  value={i}
                >
                  {t(crewmemberLanguageLabel[i])}
                </option>
              ),
            )}
          </AvField>
        </Col>
      </Row>
      <Row>
        <Col sm={8}>
          <AvField
            label={t('Qualification')}
            name={'Qualification'}
            value={item.Qualification}
          />
        </Col>
        <Col>
          <AvField
            label={t('Membership')}
            name={'Membership'}
            value={item.Membership}
          />
        </Col>
      </Row>
    </>
  );
};

export default CrewmemberFieldsView;
